const logIn = userData => {
    return {
        type: 'LOGIN',
        userData
    }
};

const logOut = () => {
    return {
        type: 'LOGOUT'
    }
};

export default {
    logIn,
    logOut
}